import React, { Component } from 'react';
import './ImageSlider.css'
import {Link} from 'react-router-dom'
class ImageSlider extends Component {

    constructor(props){
	super(props)
	this.state = {
	    currentIndex: 0
	}
    }

    componentDidMount() {
	this.animationLoop()
    }


    animationLoop(){
	let that = this
	setTimeout(function(){
	    if(!that.state.touched){
		that.scrollTo(that.state.currentIndex+1)
		that.animationLoop()
	    }
	}, 4000)
    }

    scrollAnimation(imagesCont, scrollWidth, index, count, duration) {
	 var direction = null;
	 let that = this
	 if(count<=duration)
	     setTimeout(function(){
		if(imagesCont.scrollLeft < index*scrollWidth )
		    direction = 1
		else if(imagesCont.scrollLeft > index*scrollWidth )
		    direction = -1
		else
		    direction = 0
		
		imagesCont.scrollTo((index+direction*-1)*scrollWidth+(scrollWidth*direction*count/duration), 0);
		
		that.scrollAnimation(imagesCont, scrollWidth, index, count+1, duration)   	
	    }, 1);
	
    }


    scrollTo(currentIndex, touched){
	touched = touched || false
	if(this.refs.images && this.refs.images.childElementCount){
	    currentIndex = currentIndex>=0 ? currentIndex%this.refs.images.childElementCount : this.refs.images.childElementCount-1
	    this.scrollAnimation(this.refs.images, this.refs.images.clientWidth, currentIndex, 0, 100)
	    this.setState({currentIndex})

	    this.setState({touched})
	}
	
    }

    
    render() {
	const {images, type} = this.props;
	let {currentIndex} = this.state


	

	return (
	    <div className={['imageSlider', type].join(' ')} >
		<div className="row" style={{overflow: 'hidden', flexWrap: 'nowrap'}} ref="images">
		    {
			images ? images.map((image, index) => 
			    {return (<div className="col-12 image" key={index}><img  src={image.image} className="full-width" alt={image.title} />
				
				{type === 'bottom' ?
				 <div className="titleBottom">
				     <h2><Link to={image.link}>{image.title}</Link></h2>
				 </div>
				 : null}

			    </div>)}
			) : ''
		    }
		</div>
		{type === 'top' ?
		 <div>
		     <div className="title">
			 <div>
			     <h2><img src="/ro-80.png" alt="logo" /></h2>
			 </div>
		     </div>
		     
		     <div className="availableImages">
			 {
			     images ? images.map((image, index) => 
				 {return (<i key={index} className={['fa', 'fa-circle',  (currentIndex===index ? 'current' : '')].join(" ")} onClick={() => {this.scrollTo(index, true)}}></i>)}
			     ) : null
			 }
		     </div>
		 </div>
		 :
		 <div>
		     
		     <div className="actionLeft"><i className="fa fa-angle-left" onClick={() => this.scrollTo(currentIndex-1, true)}></i></div>
		     <div className="actionRight"><i className="fa fa-angle-right" onClick={() => this.scrollTo(currentIndex+1, true)}></i></div>
		 </div>
		}
	    </div>

	);
    }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/ImageSlider/index.jsx